import {Component, Vue} from 'vue-property-decorator';
import {
  summeryIcon,
  partnerIcon,
  businessIcon,
  usersIcon,
  offersIcon,
  ordersIcon,
  customerIcon,
  invoicesIcon,
} from '@deanone/dean-components';
import axios from 'axios';
import {authUserHasPrivilegeAndAction} from "@/mixins/privileges";
import {UserAction} from "@/enums/UserAction";
import {UserPrivilege} from "@/enums/UserPrivilege";

@Component({})
export default class SideMenuPartnerMixin extends Vue {
  public sideMenu: any = {};

  public buildSideMenuPartner() {
    const sideMenu = this.$store.getters.getSideMenu;

    const pid = this.$route.params.pid;
    if (!sideMenu.content || pid !== sideMenu.content.lastId || sideMenu.content.sideMenuName !== 'partner') {
      axios.post('/-/trade/api/partner.info', {
        id: pid,
      }).then(
        (response: any) => {
          this.sideMenu = {
            content: {
              title: {
                text: `Partner ${response.data.name} (${response.data.code})`,
                mobile: {
                  close: {
                    text: 'Close',
                    icon: invoicesIcon,
                  },
                },
              },
              type: 'themed',
              sections: {
                general: {
                  title: 'Partnergegevens',
                  items: {
                    overview: {
                      title: 'Gegevens',
                      icon: summeryIcon,
                      name: 'partners.edit',
                      params: {pid},
                    },
                  },
                },
              },
              sideMenuName: 'partner',
              lastId: pid,
            },
          };

          if (authUserHasPrivilegeAndAction(UserPrivilege.PARTNER_AGREEMENT, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['agreements'] = {
              title: 'Overeenkomsten',
              icon: partnerIcon,
              name: 'partners.agreements.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.ADDRESS, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['addresses'] = {
              title: 'Adressen',
              icon: businessIcon,
              name: 'partners.addresses.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.USER, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['users'] = {
              title: 'Gebruikers',
              icon: usersIcon,
              name: 'partners.users.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.CONTACT, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['contacts'] = {
              title: 'Contacten',
              icon: usersIcon,
              name: 'partners.contacts.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.QUOTE, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['quotes'] = {
              title: 'Offertes',
              icon: offersIcon,
              name: 'partners.quotes.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.ORDER, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['orders'] = {
              title: 'Orders',
              icon: ordersIcon,
              name: 'partners.orders.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.INVOICE, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['invoices'] = {
              title: 'Facturen',
              icon: invoicesIcon,
              name: 'partners.invoices.list',
              params: {pid},
            };
          }

          if (authUserHasPrivilegeAndAction(UserPrivilege.CUSTOMER, UserAction.VIEW)) {
            this.sideMenu.content.sections.general.items['customers'] = {
              title: 'Klanten',
              icon: customerIcon,
              name: 'partners.customers.list',
              params: {pid},
            };
          }

          this.$store.dispatch('updateSideMenu', this.sideMenu);
        },
        (error: any) => {
          this.$toast({
            theme: 'danger',
            text: 'Zijmenu kon niet ingeladen worden',
          });
        },
      );
    }
  }
}
